import React from 'react';
import { PendingRows } from '../../Skeleton';
import BulkUploadIntakeV2 from '../v2/BulkUploadIntakeV2';
import { BulkUploadResponsesPanel, BulkUploadSectionTitle } from '../styles';
import { BulkUploadWizardShell } from './BulkUploadWizardShell';

export const TASKS_BULK_UPLOAD_STEPS = [
  { id: 1, label: 'Add responses' },
  { id: 2, label: 'Organise pages' },
  { id: 3, label: 'Review' },
];

// The draft snapshot or pipeline is still unknown. Keep its writes disabled
// until we know which workflow owns the draft and which step it resumes at.
export default function BulkUploadPendingStep({
  steps,
  currentStep,
  notice,
  ...props
}) {
  const title =
    steps?.find((item) => item.id === currentStep)?.label || 'Add responses';
  if (title === 'Add responses') {
    return (
      <BulkUploadIntakeV2
        {...props}
        steps={steps}
        currentStep={currentStep}
        resolving
        notice={notice}
      />
    );
  }
  return (
    <BulkUploadWizardShell
      {...props}
      steps={steps}
      currentStep={currentStep}
      showBack={Boolean(props.onBack)}
      isContinueDisabled
    >
      <BulkUploadResponsesPanel>
        <BulkUploadSectionTitle>{title}</BulkUploadSectionTitle>
        {notice || <PendingRows aria-label={title} />}
      </BulkUploadResponsesPanel>
    </BulkUploadWizardShell>
  );
}
